import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import {
  Badge,
  Collapse,
  Divider,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
} from '@mui/material';
import { muiStyles } from '.';

export const renderListItems = (arr, active, onChange, expandedItem) => {
  return arr.map((item, idx) => {
    if (item === '-') {
      return <Divider key={idx} />;
    }
    return (
      <RenderList
        idx={idx}
        item={item}
        active={active}
        expandedItem={expandedItem}
        onChange={onChange}
      />
    );
  });
};

const RenderList = ({ item, active, expandedItem, idx, onChange }) => {
  const isActive = active && item.key === active.key;
  const hasChildren = item.children && item.children.length > 0;
  const expanded = isActive || item?.key === expandedItem?.key;
  const [isOpen, setOpen] = useState(false);
  return (
    <>
      <ListItemButton
        // button
        key={idx}
        selected={isActive}
        onClick={e => {
          onChange(e, item);
          setOpen(!isOpen);
        }}
        style={muiStyles.listItem.root}
        value={item}
      >
        <ListItemIcon>
          {item.icon && React.cloneElement(item.icon, {})}
        </ListItemIcon>
        <ListItemText primary={item.label} secondary={item.description} />
        <ListItemSecondaryAction>
          {item.badge > 0 ? (
            <Badge count={item.badge} style={muiStyles.badge} />
          ) : null}
        </ListItemSecondaryAction>
        {hasChildren && (isOpen && expanded ? <ExpandLess /> : <ExpandMore />)}
      </ListItemButton>
      {hasChildren && (
        <Collapse in={isOpen} timeout='auto' unmountOnExit>
          <List component='div' disablePadding>
            {renderListItems(item.children, active, onChange, expandedItem)}
          </List>
        </Collapse>
      )}
    </>
  );
};

RenderList.propTypes = {
  item: PropTypes.object.isRequired,
  active: PropTypes.any.isRequired,
  expandedItem: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  idx: PropTypes.any.isRequired,
};

export default RenderList;
